module.exports = __webpack_public_path__ + "img/login-qr.d1caa9ad.png";